
















































































































































































































































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'Control',
  data() {
    return {
      form: {
        text: '',
        paper: {
          source: 'photo',
          hasLine: true,
          paper: '',
          upload: null,
          size: (this.$t('paper.size') as unknown as formSelectData)[1].value,
          direction: (this.$t(
            'paper.direction',
          ) as unknown as formSelectData)[0].value,
          lineCount: 22,
          marginInText: '10 10 10 10',
          backgroundColor: '#fafafa',
        },
        character: {
          font: (this.$t('font') as unknown as formSelectData)[0].value,
          upload: null,
          scale: 100,
          color: '#000000',
          spacing: -0.2,
        },
        simulation: {
          textEffect: {
            shadow: {
              color: '#666666',
              offset: {
                horizontal: 1.5,
                vertical: 1.5,
              },
              radius: 1.5,
            },
            blurRadius: 1.0,
            opacity: 85,
            distortion: this.$t('inDeveloping') as unknown as number,
          },
          randomOffset: {
            lineBeginning: 1.6,
            horizontal: 0.05,
            vertical: 0.15,
          },
          paperRotation: 1.5,
        },
      } as formType,
    };
  },
  methods: {
    updatePaperPaper(): void {
      this.form.paper.paper = this.form.paper.hasLine
        ? (this.$t('paper.line') as unknown as formSelectData)[0].value
        : (this.$t('paper.noline') as unknown as formSelectData)[0].value;
    },
  },
  props: {
    downloadDisabled: Boolean,
  },
  mounted() {
    this.updatePaperPaper();
  },
  watch: {
    'form.paper.hasLine': 'updatePaperPaper',
  },
});
